import React, { ButtonHTMLAttributes } from 'react';

type ActionButtonTypes = ButtonHTMLAttributes<HTMLButtonElement>;

const ActionButton: React.FC<ActionButtonTypes> = ({ children, ...props }) => {
  return (
    <button
      className="rounded border border-primary-700 bg-primary-700 py-2 px-4 text-base font-medium text-white transition duration-150 ease-in-out hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-700 focus:ring-offset-2 disabled:border-gray-200 disabled:bg-gray-300"
      {...props}
    >
      {children}
    </button>
  );
};

export default ActionButton;
